module.exports = __webpack_public_path__ + "static/media/help_title_with.ad90b4e3.png";